import Vue from 'vue';
import router from "../../router";

const Bus = new Vue({

    router,

});
export default Bus;



// WEBPACK FOOTER //
// ./src/common/js/bus.js